<template>
	<div class="pdf-box">
		<pdf ref="pdf" :src="pdfUrls"></pdf>
		
		<van-button type="primary" class="submit" block @click="handleSubmit">下载</van-button>
	</div>
</template>

<script>
	// import axios from './axios'
	import {
		reqProcessCode,
		reqEvaluateAdd,
		getPdfBlob
	} from '../../api'
	import {
		Toast
	} from 'vant';
	import pdf from 'vue-pdf'
	import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
	export default {
		metaInfo: {
			meta: [{
				name: 'viewport',
				content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes'
			}]
		},
		components: {
			pdf
		},
		data() {
			return {
				pdfUrls: '',
				pdfName: '',
				numpages:0,
				pdfobj:{},
			}
		},
		created() {
			this.ids = this.$route.query.id;
			this.pdfobj = this.$route.query
			this.getPdf()
			
			// this.pdfUrls = pdf.createLoadingTask(this.pdfobj.fileUrl) //pdf.createLoadingTask解决文件件跨域问题
		},
		mounted() {},
		methods: {
			getPdf() {				
				let paths = this.pdfobj.fileUrl
				// let paths = 'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf' //你获取到的pdf路径
				Toast.loading({
				  message: 'pdf加载中...',
				});
				this.$nextTick(()=>{					
					this.pdfUrls = pdf.createLoadingTask({
						url:paths,
						CMapReaderFactory
					}) //pdf.createLoadingTask解决文件件跨域问题
					this.pdfUrls.promise.then(pdf=>{
						Toast.clear()
						console.log(pdf)
					}).catch(err=>{
						console.log(err)
						Toast.clear()
					})
				})
				var arr = paths.split('/')
				var names = arr[arr.length-1]
				console.log(names)
				
				// getPdfBlob(names).then(res=>{
				// 	console.log(res)
				// })
				// this.pdfUrls = paths
				// console.log(this.pdfobj)
			},
			handleSubmit() {
				// if (!this.pdfUrls) {
				// 	return;
				// }
				// axios({
				// method: 'get',url:'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf',responseType:"arraybuffer"})
				//   .then(res =>{
					  this.fileDownload(this.pdfobj.fileUrl)
					  
				//   });
				// this.axios({
				// 	method:"get",
				// 	responseType:"arraybuffer",
				// 	url:'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf'
				// }).then(res=>{
				// 	this.fileDownload(res.data)
				// }).catch(err=>{
				// 	console.log(err)
				// })
			},
			fileDownload(data){
				// let url = window.URL.createObjectURL(new Blob([data,{type:`application/pdf`}]));
				let url = data
				let link = document.createElement('a');
				link.style.display = 'none';
				link.href = url;
				console.log(link)
				link.setAttribute('download', '发票.pdf');
				document.body.appendChild(link);
				link.click();
			},
		}
	}
</script>


<style lang="stylus" rel="stylesheet/stylus">
	@import "../../common/stylus/mixins.styl"
</style>
<style>
	.pdf-box {
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		max-width: 1024px;
		width: 100%;
		margin: 0 auto;
		overflow-x: hidden;
		height: 100%;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
		font-size: .28rem;

	}

	.pdf-box span {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/invoicing/invoicingPreview.vue